// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const AuthModalRecord = require('client-v2/common/containers/auth-modal/record')
const ConfirmModalRecord = require('client-v2/common/containers/confirm-modal/record')
const ToastsRecord = require('client-v2/common/containers/toasts/record')
const EnvRecord = require('client-v2/common/state/env/record')
const RouterRecord = require('client-v2/common/state/router/record')
const UserRecord = require('client-v2/common/state/user/record')
const { keyedReviver } = require('client-v2/common/state/revivers')
// Entry imports
const SMSModalRecord = require('client-v2/into-landing/containers/sms-modal/record')

class LandingVideoRecord extends Immutable.Record({
  posterUrl: String(),
  videoUrl: String()
}) {
  // No methods
}

LandingVideoRecord.reviver = keyedReviver(LandingVideoRecord, {
  // No nested data structures
})


class LandingRootRecord extends Immutable.Record({
  // Common state
  env: null,
  router: null,
  user: null,
  // Common containers
  authModal: null,
  confirmModal: null,
  toasts: null,
  // Entry containers
  smsModal: null,
  video: null
}) {
  // No methods
}

LandingRootRecord.reviver = keyedReviver(LandingRootRecord, {
  // Common state
  env: EnvRecord.reviver,
  router: RouterRecord.reviver,
  user: UserRecord.reviver,
  // Common containers
  authModal: AuthModalRecord.reviver,
  confirmModal: ConfirmModalRecord.reviver,
  toasts: ToastsRecord.reviver,
  // Entry containers
  smsModal: SMSModalRecord.reviver,
  video: LandingVideoRecord.reviver
})

module.exports = LandingRootRecord
